// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AvailablePlansInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AvailablePlansInput — query params for
 * GET /subscriptions/available-plans.
 *
 * Optional:
 *   franquia_id — when present, filter to that franchise's market currency
 *                 (with BRL fallback). Must be a positive integer when given.
 */
import { registerContract } from './validate'

export interface Subscriptions_AvailablePlansInput {
franquia_id?: number
}

registerContract('Subscriptions_AvailablePlansInput', {
  franquia_id: { type: 'number',  required: false },
})
